module.exports = __webpack_public_path__ + "img/login-ibs-bg.adb7c81d.png";